import type { GeocodeHit, ParcelDTO } from "../../api";
import { Badge, Card } from "../../ui";

interface SelectedPointCardProps {
  selected: GeocodeHit | null;
  parcels: ParcelDTO[] | null;
  parcelElapsed: number | null;
}

export function SelectedPointCard({
  selected,
  parcels,
  parcelElapsed,
}: SelectedPointCardProps) {
  return (
    <Card
      title="Punto selezionato"
      sub={selected ? "dettaglio indirizzo" : "nessun punto"}
    >
      {!selected ? (
        <div style={{ color: "var(--text-2)", fontSize: 13 }}>
          Digita un indirizzo o clicca sulla mappa per iniziare.
        </div>
      ) : (
        <div className="col gap-10">
          <div className="preview-box" style={{ fontSize: 12 }}>
            <div style={{ marginBottom: 6 }}>
              <strong style={{ fontSize: 13 }}>
                {selected.address?.road || ""} {selected.address?.houseNumber || ""}
              </strong>
            </div>
            <div>
              <span className="muted">comune</span>{" "}
              <strong>{selected.address?.city || "—"}</strong>
              {selected.address?.postcode && (
                <>
                  {" · "}
                  <span className="muted">CAP</span>{" "}
                  <span className="mono">{selected.address.postcode}</span>
                </>
              )}
            </div>
            <div>
              <span className="muted">provincia</span>{" "}
              <strong>{selected.address?.province || "—"}</strong>{" "}
              {selected.address?.provinceCode && (
                <Badge kind="accent">{selected.address.provinceCode}</Badge>
              )}
            </div>
            <div
              className="mono"
              style={{ fontSize: 10, color: "var(--text-3)", marginTop: 4 }}
            >
              {selected.lat.toFixed(5)}, {selected.lon.toFixed(5)}
            </div>
          </div>
          {parcels !== null && (
            <div className="row gap-6" style={{ alignItems: "center" }}>
              <Badge kind={parcels.length > 0 ? "accent" : "muted"}>
                {parcels.length} particelle catastali
              </Badge>
              {parcelElapsed !== null && (
                <Badge kind="muted" className="mono">
                  {parcelElapsed} ms
                </Badge>
              )}
            </div>
          )}
          {parcels && parcels.length > 0 && (
            <div className="col gap-4" style={{ maxHeight: 100, overflowY: "auto" }}>
              {parcels.slice(0, 3).map((parcel) => (
                <div
                  key={parcel.inspireid}
                  className="mono"
                  style={{ fontSize: 10, color: "var(--text-2)" }}
                >
                  · {parcel.nat_ref}
                </div>
              ))}
              {parcels.length > 3 && (
                <div className="muted" style={{ fontSize: 10 }}>
                  … altre {parcels.length - 3}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </Card>
  );
}
